<template>
  <section>
    <label
      for="transition-duration"
      class="block text-sm leading-5 font-medium text-gray-700 mb-2 mt-4"
      >Transition duration <span class="text-gray-500">(pixels)</span></label
    >
    <v-select
      v-model="element.duration"
      :options="transitionDuration"
      class="mb-4 bg-white"
    ></v-select>
  </section>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: ["element"],

  data() {
    return {
      transitionDuration: [100, 200, 300, 400, 500, 600, 700, 800],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
